<div class="flex flex-col justify-center items-center pt-[100px] z-10">
    <div class="px-4 sm:px-[20%] text-center text-sm sm:text-base relative z-10">
        SEM Nexus is an award-winning mobile app agency specializing in helping healthcare apps succeed. While we work
        with apps of all kinds, our experience in healthcare is unparalleled. Whether it's a telehealth platform,
        fitness tracker, or wellness solution, we craft targeted campaigns to get your app into the hands of the right
        users. From strategy to execution, we focus on maximizing downloads and engagement. Partner with SEM Nexus to
        elevate your healthcare app's marketing and stand out in the competitive landscape.
    </div>
</div>